module.exports = "query ($reference: ID!) {\n  Project(id: $reference) {\n    id\n    name\n    segment\n  }\n}\n"